export const RATING_PERMISSIONS = {
  pageId: 75,
  name: 'Rating',
  path: 'rating',
} as const;
